import React from "react";
import Header from "./components/Header";
import Sidebar from "./components/sidebar";
import Main from "./components/Main";
import { Provider } from "./store/context/ContextProvider";
const App = () => {
  return (
    <Provider>
      <div className="w-full fixed">
        <Header />
        <div className="grid grid-cols-4">
          <div className="sm:col-span-2 h-auto md:col-span-1">
            <Sidebar />
          </div>
          <div className="sm:col-span-2 md:col-span-3 overflow-y">
            <Main />
          </div>
        </div>
      </div>
    </Provider>
  );
};

export default App;
